import styled from "styled-components"

const Container = styled.section`
  & *[class*="-title"]::before,
  & *[class*="-title"] a::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

const ArticleHeader = styled.article`
  & h1::after {
    margin-bottom: 0.75rem;
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

const NewsletterIntro = styled.h2`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
  margin: 1.5rem 0;
`

const EventsItemImg = styled.div`
  &::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

const Taxo = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const EventsItem = styled.li`
  border-bottom: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  &:hover div:first-of-type::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

export {
  Container,
  ArticleHeader,
  NewsletterIntro,
  Taxo,
  EventsItem,
  EventsItemImg,
}
